<template>
  <div id="app" :class="plaform">
    <!-- <svg-icon icon-class="search"></svg-icon> -->
    <router-view />
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      plaform: "mobile",
    };
  },
  created() {
    // Cookies.set("payapp_token","zhangxiaoxiong_289_89_237dd8b4ea594fb4a1514d307563aa1f")
    let that = this;
    this.watchWidth(that);
    window.onresize = function () {
      that.watchWidth(that);
    };
  },
  methods: {
    watchWidth(that) {
      if (document.documentElement.clientWidth > 640) {
        require("@/assets/css/pc/index.scss");
        that.plaform = "pc";
      } else {
        require("@/assets/css/mobile/index.scss");
        that.plaform = "mobile";
      }
    },
  },
};
</script>


<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.noCopy {
  //禁止复制
  -moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
html,
body,
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  // font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
  //   Arial, PingFang SC-Light, Microsoft YaHei;
  font-family: "Microsoft YaHei", 微软雅黑, "Microsoft JhengHei", 华文细黑,
    STHeiti, MingLiu;
  background: rgb(247, 248, 253);
}
</style>
